// Single source of truth for brand assets. Exactly three files exist:
//   /iconandfavicon.png  – app icon + favicon (all stores)
//   /logo.png            – normal ModeskPOS logo
//   /logo-lottery.png    – logo for Lottery-only licensed stores
export const BRAND_ICON = "/iconandfavicon.png?v=8.58";
export const brandLogo = () => (localStorage.getItem("lottery_only_cache") === "1" ? "/logo-lottery.png" : "/logo.png");
